import {Button, Dropdown} from "react-bootstrap";
import {Filter, Plus} from "lucide-react";
import SchedulerStatusTabs from "./SchedulerStatusTabs";
import {taskStatusOptions} from "./boardConfigs";

const taskTypeOptions = [
    {value: "ALL", label: "All types"},
    {value: "DEEP_CLEAN", label: "Deep clean"},
    {value: "GENERAL", label: "General"},
];

export default function TaskStatusTabs({selectedStatus, statusCounts, onChange, taskType, onTaskTypeChange, onCreateTask, createDisabled = false}) {
    const selectedType = taskType || "ALL";
    const hasTypeFilter = selectedType !== "ALL";
    const typeLabel = taskTypeOptions.find(option => option.value === selectedType)?.label || "All types";

    return (
        <div className="scheduler-task-header">
            <div className="scheduler-task-status-controls" role="group" aria-label="Task status">
                <SchedulerStatusTabs
                    options={taskStatusOptions}
                    selectedStatus={selectedStatus}
                    statusCounts={statusCounts}
                    onChange={onChange}
                />
            </div>
            <Dropdown className="scheduler-task-filter">
                <Dropdown.Toggle
                    variant={hasTypeFilter ? "primary" : "outline-secondary"}
                    className="scheduler-task-icon-button scheduler-task-filter-toggle"
                    aria-label="Filter tasks by type"
                    aria-pressed={hasTypeFilter}
                    title={`Task type: ${typeLabel}`}
                >
                    <Filter size={18} aria-hidden="true" />
                </Dropdown.Toggle>
                <Dropdown.Menu align="end" role="menu" aria-label="Task type">
                    <Dropdown.Header>Task type</Dropdown.Header>
                    {taskTypeOptions.map(option => (
                        <Dropdown.Item
                            key={option.value}
                            as="button"
                            type="button"
                            role="menuitemradio"
                            aria-checked={selectedType === option.value}
                            active={selectedType === option.value}
                            onClick={() => onTaskTypeChange?.(option.value)}
                        >
                            {option.label}
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
            <Button
                className="scheduler-task-icon-button"
                aria-label="New Task"
                title="New Task"
                disabled={createDisabled}
                onClick={onCreateTask}
            >
                <Plus size={20} aria-hidden="true" />
            </Button>
        </div>
    );
}
